import { createApp } from 'vue';
import i18n from './i18n';

const componentMap = {
  Bodegas: () => import(/* webpackChunkName: "vue-bodegas" */ '../components/Bodegas.vue'),
  Events: () => import(/* webpackChunkName: "vue-events" */ '../components/Events.vue'),
  Educators: () => import(/* webpackChunkName: "vue-educators" */ '../components/Educators.vue'),
  Recipes: () => import(/* webpackChunkName: "vue-recipes" */ '../components/Recipes.vue'),
  Cocktails: () => import(/* webpackChunkName: "vue-cocktails" */ '../components/Cocktails.vue'),
  Sherryspots: () => import(/* webpackChunkName: "vue-sherryspots" */ '../components/Sherryspots.vue'),
  Sherryspotsuk: () => import(/* webpackChunkName: "vue-sherryspotsuk" */ '../components/Sherryspotsuk.vue'),
  Meetthemaker: () => import(/* webpackChunkName: "vue-meetthemaker" */ '../components/Meetthemaker.vue'),
  Sherrysession: () => import(/* webpackChunkName: "vue-sherrysession" */ '../components/Sherrysession.vue'),
  Sherryweek: () => import(/* webpackChunkName: "vue-sherryweek" */ '../components/Sherryweek.vue'),
  Educator: () => import(/* webpackChunkName: "vue-educators" */ '../components/Educators.vue'),
};

const mountEl = document.querySelector("#app");

if (mountEl) {
  const formtype = mountEl.dataset.formtype;
  const loader = componentMap[formtype];

  if (loader) {
    loader().then((module) => {
      const app = createApp(module.default, { ...mountEl.dataset });
      app.use(i18n);
      app.mount('#app');
    });
  }
}

window.document.addEventListener("DOMContentLoaded", function () {
  window.console.log("dom ready 2");
});
